export const tr = {
    apply: 'Uygula',
    'continue-edit': 'Düzenlemeye devam et',
    'creative-to-create': {
        one: '{count} kreatif oluşturulacak',
        some: '{count} kreatif oluşturulacak',
        many: '{count} kreatif oluşturulacak',
        none: '{count} kreatif oluşturulacak'
    },
    'crop-again': 'Yeniden kırp',
    'default-name': 'Yeni grup',
    ok: 'OK',
    'previews-cancel': 'İptal',
    'previews-save': 'Boyutları seç ve devam et',
    'previews-title': 'Kreatif önizleme',
    'show-all-previews': 'Tümünü göster'
};
